import ExperienceHeader from "./ExperienceHeader";
import LogoMarquee from "./LogoMarquee";

function ExperienceSection({ darkMode }) {
  return (
    <section className="bg-background-light dark:bg-background-dark">
      <div className="max-w-5xl mx-auto px-6 pt-24 pb-16">
        <ExperienceHeader />
      </div>

      <div className="max-w-5xl mx-auto px-6 pb-24">
        <LogoMarquee darkMode={darkMode} />
      </div>
    </section>
  );
}

export default ExperienceSection;
